import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link, Navigate } from 'react-router';
import { reduxForm, reset, getFormValues } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import * as trsActions from '../../actions/masterDataManagementActions';
import MasterDataManagementTRSHeader from '../../components/masterDataManagement/MasterDataManagementTRSHeader';
import MasterDataManagementTRSComponent from '../../components/masterDataManagement/MasterDataManagementTRSComponent';
import * as commonActions from '../../actions/commonActions';
import * as reitActions from '../../actions/reitActions';
import UploadTRSModal from '../../components/masterDataManagement/UploadTRSModal';
import AddEditTRSModal from '../../components/masterDataManagement/AddEditTRSModal';
import DeleteTRSConfirmationModal from '../../components/masterDataManagement/DeleteTRSConfirmationModal';
import isEqual from 'lodash/isEqual';

/**
 * MasterDataManagementTRSContainer component
 * @extends {React.Component}
 */
class MasterDataManagementTRSContainer extends Component {
  /**
   * Creates a new MasterDataManagementTRSContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);
    this.state = {
      gridCurrentState: [],
      reits: [],
      selectedReits: [],
      checkSelectedReit: [],
      gridColumnState: {},
      refreshGridTRSData: {
        refreshGridOnCompletedAction: -1,
      },
      isEdit: false,
      showAddEditTRSModal: false,
      resetCheckboxes: false,
      addTRSModalHeader: '',
      showUploadTRSModal: false,
      selectedTRS: {
        taxableREITSubsidiaryMasterID: 0,
        trsElectionDate: null,
        trsEndDate: null,
        reitName: null,
        trsName: '',
        reitID: 0,
      },
    };

    // Bind methods
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.handleEditButtonClick = this.handleEditButtonClick.bind(this);
    this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this);
    this.handleDismissErrorMessage = this.handleDismissErrorMessage.bind(this);
    this.handleAddTRS = this.handleAddTRS.bind(this);
    this.handleSaveTRS = this.handleSaveTRS.bind(this);
    this.handleExportTRSImportTemplate =
      this.handleExportTRSImportTemplate.bind(this);
    this.handleUploadTRSImportTemplate =
      this.handleUploadTRSImportTemplate.bind(this);
    this.handleDownloadMasterDataReport =
      this.handleDownloadMasterDataReport.bind(this);
    this.clearValidationMessage = this.clearValidationMessage.bind(this);
    this.handleCloseForm = this.handleCloseForm.bind(this);
    this.toggleShowAddEditTRSModal = this.toggleShowAddEditTRSModal.bind(this);
    this.handleConfirmButtonClick = this.handleConfirmButtonClick.bind(this);
    this.toggleShowDeleteTRSConfirmationModal =
      this.toggleShowDeleteTRSConfirmationModal.bind(this);
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    if (this.props.clientId) {
      // Fetch TRS data
      this.props.trsActions.fetchTRSData(this.props.clientId);
      this.props.reitActions.fetchReits(this.props.clientId, false);
    }
  }

  componentDidUpdate(prevProps) {
    // Check if masterDataManagementTRSFormValues have changed
    if (
      !isEqual(
        prevProps.masterDataManagementTRSFormValues,
        this.props.masterDataManagementTRSFormValues
      ) &&
      this.props.masterDataManagementTRSFormValues &&
      prevProps.masterDataManagementTRSFormValues
    ) {
      // Add additional logic here to check for specific fields if needed
      this.props.trsActions.fetchTRSData(this.props.clientId);
      this.props.reitActions.fetchReits(this.props.clientId, false);
    }
  }

  componentWillUnmount() {
    this.setState({
      trsData: [],
      reits: [],
      selectedReits: [],
      checkSelectedReit: [],
      selectedTRS: {},
    });
  }

  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
  }

  fetchTRSData() {
    const { clientId } = this.props;
    if (clientId) {
      this.props.trsActions.fetchTRSData(this.props.clientId);
    }
  }

  clearValidationMessage() {
    if (this.state.validationMessage != '') {
      this.setState({ validationMessage: '' });
    }

    if (this.state.electionValidationMessage != '') {
      this.setState({ electionValidationMessage: '' });
    }

    if (this.state.endDateValidationMessage != '') {
      this.setState({ endDateValidationMessage: '' });
    }

    if (this.state.errorMessage !== '') {
      this.setState({ errorMessage: '' });
    }
  }

  refreshGrid(selectedData = []) {
    this.fetchTRSData();

    const randomNumber = parseInt(Math.random() * (99999999 - 1)) + 1;
    if (
      selectedData &&
      Array.isArray(selectedData) &&
      selectedData.length > 0
    ) {
      this.setState({
        refreshGridTRSData: {
          refreshGridOnCompletedAction: randomNumber,
        },
      });
    } else {
      this.setState({
        refreshGridTRSData: {
          refreshGridOnCompletedAction: randomNumber,
        },
      });
    }
  }

  handleAddTRS() {
    this.props.reitActions.fetchReits(this.props.clientId, false);
    this.props.dispatch(reset('addEditTRSForm'));
    this.setState({
      showAddEditTRSModal: true,
      isEdit: false,
      selectedTRS: {
        taxableREITSubsidiaryMasterID: 0,
        reitID: 0,
        trsElectionDate: null,
        trsEndDate: null,
        reitName: null,
        trsName: '',
      },
    });
    this.clearValidationMessage();
  }

  handleGridChanges(gridRowData) {
    let rowData = [];
    rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          taxableREITSubsidiaryMasterID: x.taxableREITSubsidiaryMasterID,
          reitName: x.reitName,
          reitShortName: x.reitShortName,
          reitID: x.reitID,
          isActive: x.isActive,
          reitSuiteEntityIDForREIT: x.reitSuiteEntityIDForREIT,
          trsElectionDate: x.trsElectionDate,
          trsInitialQuarter: x.trsInitialQuarter,
          trsEndDate: x.trsEndDate,
          trsFinalQuarter: x.trsFinalQuarter,
          trsName: x.trsName,
          lastUpdatedBy: x.lastUpdatedBy,
          lastUpdatedDate: x.lastUpdatedDate,
          isCannotBeDeleted: x.isCannotBeDeleted,
        };
      });
    this.setState({ gridCurrentState: rowData });
  }

  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  handleEditButtonClick(trs) {
    this.clearValidationMessage();
    this.props.reitActions.fetchReits(this.props.clientId, false);
    if (trs) {
      (this.props.dispatch(reset('addEditTRSForm')),
        this.setState({
          showAddEditTRSModal: true,
          selectedTRS: {
            TaxableREITSubsidiaryMasterID: trs.taxableREITSubsidiaryMasterID,
            TRSElectionDate: trs.trsElectionDate,
            TRSEndDate: trs.trsEndDate,
            ReitShortName: trs.reitShortName,
            TRSName: trs.trsName,
            REITID: trs.reitid,
          },
          isEdit: true,
        }));
    }
  }

  toggleShowAddEditTRSModal() {
    this.setState({
      showAddEditTRSModal: !this.state.showAddEditTRSModal,
      validationMessage: '',
      electionValidationMessage: '',
      endDateValidationMessage: '',
      errorMessage: '',
    });
  }
  handleDismissErrorMessage() {
    this.props.commonActions.clearFormErrors('addEditTRSForm');
  }

  toggleShowDeleteTRSConfirmationModal() {
    this.setState({
      showDeleteTRSConfirmationModal:
        !this.state.showDeleteTRSConfirmationModal,
    });
  }

  handleDeleteButtonClick = (values) => {
    if (values) {
      this.setState({
        showDeleteTRSConfirmationModal: true,
        apiErrorMessage: '', // Clear any previous error message,
        selectedTRS: {
          TaxableREITSubsidiaryMasterID: values.taxableREITSubsidiaryMasterID,
          TRSName: values.trsName,
          REITID: values.reitid,
        },
      });
    }
  };

  handleConfirmButtonClick = (values) => {
    if (values) {
      this.props.trsActions
        .deleteTRS(
          this.props.clientId,
          this.state.selectedTRS.REITID,
          this.state.selectedTRS.TaxableREITSubsidiaryMasterID
        )
        .then((response) => {
          if (response && response.success) {
            this.setState({
              showDeleteTRSConfirmationModal: false,
              selectedTRS: null,
              apiErrorMessage: '', // Clear any previous error message
            });
            this.refreshGrid();
          } else {
            this.setState({
              apiErrorMessage:
                response.errorMessage ||
                'An error occurred while deleting the group.',
            });
          }
        })
        .catch((error) => {
          this.setState({
            apiErrorMessage: error.message || 'An unexpected error occurred.',
          });
        });
    }
  };

  handleCloseForm() {
    this.setState({
      showAddEditTRSModal: false,
      selectedTRS: {
        taxableREITSubsidiaryMasterID: 0,
        trsElectionDate: null,
        trsEndDate: null,
        reitName: null,
        trsName: '',
        reitID: 0,
      },
    });
  }

  handleSaveTRS(values) {
    this.props.commonActions.beginTask();

    const trs = {
      ClientID: this.props.clientId,
      REITID: values.REITID,
      TRSElectionDate: values.TRSElectionDate,
      TRSEndDate: values.TRSEndDate,
      TRSName: values.TRSName,
      TaxableREITSubsidiaryMasterID: values.TaxableREITSubsidiaryMasterID,
      REITName: values.REITName,
    };

    const { isEdit } = this.state;
    // Note: updateTRS is static on trsActions, but createTRS is from props.
    const action = isEdit
      ? trsActions.updateTRS(trs)
      : this.props.trsActions.createTRS(trs);
    const actionName = isEdit ? 'updating' : 'creating';

    return action
      .then((response) => this.handleTRSResponse(response, isEdit))
      .catch(() => {
        this.setState({
          validationMessage: `An error occurred while ${actionName} the TRS.`,
        });
      })
      .finally(() => {
        this.props.commonActions.endTask();
      });
  }

  handleTRSResponse(response, isEdit) {
    if (response && response.success) {
      this.toggleShowAddEditTRSModal();
      if (isEdit) {
        this.handleCloseForm();
      }
      this.refreshGrid();
      return; // Success case
    }

    // Error handling
    if (
      response?.response?.errorCode === 'BAD_REQUEST' ||
      (response?.response?.errorCode && response?.response?.message)
    ) {
      this.setState({ validationMessage: response.response.message });
    } else if (
      response?.errorCode === 'BAD_REQUEST' ||
      response?.errorResponse?.errorCode === 'BAD_REQUEST'
    ) {
      this.setState({
        errorMessage: response?.message || response?.errorResponse?.message,
      });
    } else if (response?.errorMessage?.includes('Election Date')) {
      this.setState({ electionValidationMessage: response.errorMessage });
    } else if (response?.errorMessage?.includes('End Date')) {
      this.setState({ endDateValidationMessage: response.errorMessage });
    } else if (response?.errorMessage) {
      this.setState({ validationMessage: response.errorMessage });
    } else {
      const action = isEdit ? 'updating' : 'creating';
      this.setState({
        validationMessage: `An error occurred while ${action} the TRS.`,
      });
    }
  }

  handleExportTRSImportTemplate() {
    this.props.trsActions.exportTRSData(this.props.clientId);
  }

  handleUploadTRSImportTemplate() {
    this.setState({ showUploadTRSModal: true });
  }

  toggleUploadTRSModal = (clientID) => {
    this.setState({ showUploadTRSModal: !this.state.showUploadTRSModal });

    if (clientID && clientID === this.props.clientId) {
      this.props.trsActions.fetchTRSData(this.props.clientId);
      this.props.reitActions.fetchReits(this.props.clientId, false);
      this.props.dispatch(reset('masterDataManagementTRSForm'));
    }
  };

  handleDownloadMasterDataReport() {
    this.props.trsActions.exportAllTypesData(this.props.clientId);
  }

  render() {
    if (this.props.isAudit) {
      return (
        <Navigate to={`/client/${this.props.clientId}/masterDataManagement`} />
      );
    }

    return (
      <div>
        <h2 data-testid="pghdrMasterDataManagement">Master Data Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/groups`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(1)}
              data-testid="tbGroups"
            >
              Groups
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/reits`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(2)}
              data-testid="tbREITs"
            >
              REITs
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/properties`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(3)}
              data-testid="tbProperties"
            >
              Properties
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/securities`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(4)}
              data-testid="tbSecurities"
            >
              Securities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/trs`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              onClick={() => this.handleTabClick(5)}
              data-testid="tbTrs"
            >
              Taxable REIT Subsidiaries
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>
        <MasterDataManagementTRSHeader
          handleAddTRS={this.handleAddTRS}
          handleExportTRSImportTemplate={this.handleExportTRSImportTemplate}
          handleUploadTRSImportTemplate={this.handleUploadTRSImportTemplate}
          handleDownloadMasterDataReport={this.handleDownloadMasterDataReport}
        />

        {this.state.showUploadTRSModal && (
          <UploadTRSModal
            show={this.state.showUploadTRSModal}
            onClose={this.toggleUploadTRSModal}
            onUploadSuccess={this.refreshGrid}
          />
        )}

        <AddEditTRSModal
          resetCheckboxes={this.state.resetCheckboxes}
          reits={this.props.reits}
          editTRS={this.editTRS}
          handleCloseForm={this.handleCloseForm}
          initialValues={this.state.selectedTRS}
          onSave={this.handleSaveTRS}
          handleDismissErrorMessage={this.handleDismissErrorMessage}
          showAddEditTRSModal={this.state.showAddEditTRSModal}
          toggleShowAddEditTRSModal={this.toggleShowAddEditTRSModal}
          isEdit={this.state.isEdit}
          validationMessage={this.state.validationMessage}
          errorMessage={this.state.errorMessage}
          clearValidationMessage={this.clearValidationMessage}
          electionValidationMessage={this.state.electionValidationMessage}
          endDateValidationMessage={this.state.endDateValidationMessage}
        />

        <DeleteTRSConfirmationModal
          showDeleteTRSConfirmationModal={
            this.state.showDeleteTRSConfirmationModal
          }
          handleConfirm={this.handleConfirmButtonClick}
          toggleShowDeleteTRSConfirmationModal={
            this.toggleShowDeleteTRSConfirmationModal
          }
          gridCurrentState={this.gridCurrentState}
          initialValues={this.state.selectedTRS}
          apiErrorMessage={this.state.apiErrorMessage}
          handleDismissErrorMessage={this.handleDismissErrorMessage}
        />

        <MasterDataManagementTRSComponent
          trsData={this.props.trsData || []}
          handleGridChanges={this.handleGridChanges}
          gridColumnState={this.state.gridColumnState}
          handleGridColumnStateChange={this.handleGridColumnStateChange}
          refreshGridTRSData={this.refreshGridTRSData}
          handleEditButtonClick={this.handleEditButtonClick}
          handleDeleteButtonClick={this.handleDeleteButtonClick}
          handleDismissErrorMessage={this.handleDismissErrorMessage}
        />
      </div>
    );
  }
}

MasterDataManagementTRSContainer.propTypes = {
  clientId: PropTypes.number,
  isAudit: PropTypes.bool,
  trsActions: PropTypes.object.isRequired,
  trsData: PropTypes.array,
  commonActions: PropTypes.object,
  reits: PropTypes.array,
  selectedReits: PropTypes.array,
  checkSelectedReit: PropTypes.array,
  reitActions: PropTypes.object,
  masterDataManagementTRSFormValues: PropTypes.object,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }

  return {
    clientId: cid,
    isAudit: state.client && state.client.isAudit,
    trsData: state.trsData || [],
    reits: state.reits,
    masterDataManagementTRSFormValues: getFormValues(
      'masterDataManagementTRSForm'
    )(state),
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    trsActions: bindActionCreators(trsActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    reitActions: bindActionCreators(reitActions, dispatch),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'masterDataManagementTRSForm',
      enableReinitialize: true,
    })(MasterDataManagementTRSContainer)
  )
);
